import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Tabs, GlobalToken } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UsersTab } from './UsersTab/UsersTab';

const SettingsPage = observer(({ tabKey }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onChangeTab = value => {
    navigate(`../${value}`);
  };

  const tabItems = [
    {
      label: t('Users Management'),
      key: 'users',
      children: <UsersTab />,
    },
  ];

  return (
    <Container>
      <Tabs
        activeKey={tabKey}
        animated={{
          inkBar: true,
          tabPane: false,
        }}
        onChange={onChangeTab}
        items={tabItems}
      />
    </Container>
  );
});
const Container = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-grow: 1;
  padding: 0 ${({ theme: { token } }) => token.padding}px;
  min-width: 900px;
  height: 100%;

  .ant-tabs {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-top: ${({ theme: { token } }) => token.marginMD}px;

    .ant-tabs-nav {


      .ant-tabs-nav-wrap {
        display: flex;
        justify-content: center;

        .ant-tabs-tab {
          padding-left: ${({ theme: { token } }) => token.paddingSM}px;
          padding-right: ${({ theme: { token } }) => token.paddingSM}px;
          margin-left: ${({ theme: { token } }) => token.margin}px;
          margin-right: ${({ theme: { token } }) => token.margin}px;
          flex-grow: 0;
        }

        .ant-tabs-ink-bar {
          background-color: ${({ theme: { token } }) => token.colorPrimary};
          height: 3px;
          border-radius: 5px 5px 0px 0px;
        }
      }
    }

    .ant-tabs-content-holder {
      display: flex;
      flex-direction: column;

      .ant-tabs-content {
        flex-grow: 1;
        flex-shrink: 0;
        height: 100%;

        .ant-tabs-tabpane-active {
          overflow: scroll;
        }

        .ant-tabs-tabpane {
          height: 100%;
          &.tab-map {
            display: flex;
            flex-direction: column;

            .centerer {
              flex-basis: 1000px;
              flex-shrink: 1;
            }
          }
        }
      }
    }
  }
}

`;

export default SettingsPage;
